import React, { createContext, useContext, useMemo } from 'react'
import useItemListener from '../comps/configs/cells/useItemListener';

// ------------  Context --------------------//
const ItemListenerContext = createContext();

// ------------  STATIC  ----------------------------------------------------------------------------- //

// Actor --> useItemListenerContext()               .tagValueLocked()
//           --> useItemListener()                  .tagValueLocked()
//                --> useConfigsDataContext()       .setValueLocked (true)

// ------------  Provider ---------------------------------------------------------------------------- //
export const ItemListenerContextProvider = ({children}) => {
  
  const {
          itemChanged, 
    reasoning, setReasoning, insightRejected, setInsightRejected,
          clearErrorKeyCreated, 
          tagCreateKeyInProgress, resetCreateKeyInProgress, 
          tagKeyLocked,    resetKeyLocked, 
          tagKeyEditing, 

          clearKeyKInfo,
          
          tagValueLocked,  resetValueLocked, 
          tagValueEditing, //resetValueEditing, 
          resetValueKInfo,
          
          tagTitleLocked, resetTitleLocked, 
          tagTitleEditing, 
          resetTitleKInfo}                                     = useItemListener();



  const memoizedValue = useMemo(()=> ({
    itemChanged, reasoning, setReasoning, insightRejected, setInsightRejected,
    clearErrorKeyCreated, tagCreateKeyInProgress, resetCreateKeyInProgress, 
       tagKeyLocked,    resetKeyLocked,   tagKeyEditing,    clearKeyKInfo,
       tagValueLocked,  resetValueLocked, tagValueEditing,  resetValueKInfo,
       tagTitleLocked,  resetTitleLocked, tagTitleEditing,  resetTitleKInfo

  }), [itemChanged, reasoning, setReasoning, insightRejected, setInsightRejected,
    clearErrorKeyCreated, tagCreateKeyInProgress, resetCreateKeyInProgress, 
       tagKeyLocked,    resetKeyLocked,   tagKeyEditing,    clearKeyKInfo,
       tagValueLocked,  resetValueLocked, tagValueEditing,  resetValueKInfo,
       tagTitleLocked,  resetTitleLocked, tagTitleEditing,  resetTitleKInfo
      ]);

  return (<ItemListenerContext.Provider value={memoizedValue}>{children}</ItemListenerContext.Provider>)
}


export function useItemListenerContext() {
  return useContext(ItemListenerContext);
}